<template>
  <div class="qweb-column" :class="{ sort: sort }" @click="onSortClick">
    <span class="qweb-column-title">
      <slot></slot>
    </span>
    <div class="overlay">
      <div class="sort-default" v-if="NO_SORT"></div>
      <div class="sort-asc" v-if="ASC"></div>
      <div class="sort-desc" v-if="DESC"></div>
    </div>
  </div>
</template>
<script>
import { get } from 'lodash'
import moment from 'moment'
export default {
  name: 'column',
  props: {
    width: {
      type: String
    },
    sort: {
      type: [String, Function]
    },
    number: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    NO_SORT () {
      return (this.sort && this.order === '')
    },
    ASC () {
      return this.order === 'asc'
    },
    DESC () {
      return this.order === 'desc'
    }
  },
  data () {
    return {
      columnIndex: -1,
      order: '',
      macTable: ''
    }
  },
  mounted () {
    this.table = this.$parent
    if (this.table.$options._componentTag !== 'fixed-table') {
      this.table = this.table.$parent
    }
    let parent = this.$el.parentNode
    let headerClass = parent.className
    let right = (headerClass === 'right-header')
    this.columnIndex = Array.from(parent.children).indexOf(this.$el)
    if (this.width) {
      let columnWidthMap
      if (right) {
        columnWidthMap = this.table.getRightColumnWidthMap()
      } else {
        columnWidthMap = this.table.getLeftColumnWidthMap()
      }
      columnWidthMap.set(this.columnIndex, this.width)
    }
  },
  methods: {
    getSortValue (data) {
      let value = ''
      let date = ''
      let time = ''
      if (this.sort === 'datetime') {
        if (data && data['0008,0020']) {
          date = data['0008,0020'].Value
        }
        if (data && data['0008,0030']) {
          time = data['0008,0030'].Value
        }
        if (date && time) {
          return moment(date + ' ' + time).format('X')
        }
        return ''
      } else if (this.sort === 'key') {
        value = get(data, this.sort)[0]
      } else if (this.sort === 'macAddress') {
        value = get(data, 'key')
        value = (value === undefined) ? get(data, 'hwaddr') : get(data, 'key')[1]
      } else if (this.sort === 'name') {
        value = get(data, 'name')
      } else if (this.sort === 'time') {
        value = get(data, 'found_at')
      } else if (this.sort === 'online') {
        value = get(data, this.sort)
      } else if (this.sort === 'sourceIP' || this.sort === 'destinationIP') {
        let direction = this.sort.includes('source') ? 'sourceMask' : 'destinationMask'
        let maskValue = get(data['val'], direction).split('.')
        value = get(data['val'], this.sort)
        value = value.split('.')
        value = (parseInt(value[0]) + parseInt(maskValue[0])).toString() + (parseInt(value[1]) + parseInt(maskValue[1])).toString() + (parseInt(value[2]) + parseInt(maskValue[2])).toString() + (parseInt(value[3]) + parseInt(maskValue[3])).toString()
      } else if (this.sort === 'no.') {
        value = parseInt(get(data, 'key'))
      } else if (typeof this.sort === 'string') {
        value = get(data['val'], this.sort)
      }
      if (typeof value === 'boolean') {
        value ? value = 1 : value = 0
      }
      if (typeof value === 'object') {
        let temp = ''
        value.forEach(element => {
          temp = temp + element
        })
        value = temp
      }
      if (this.number) {
        return value
      } else if (typeof value === 'string') {
        return value
      } else {
        return value['Value']
      }
    },
    sortString (a, b) {
      let valueA = this.getSortValue(a)
      let valueB = this.getSortValue(b)
      if (this.ASC) {
        if (valueA > valueB) {
          return 1
        } else if (valueA < valueB) {
          return -1
        }
      } else {
        if (valueA < valueB) {
          return 1
        } else if (valueA > valueB) {
          return -1
        }
      }
      return 0
    },
    sortNumber (a, b) {
      let valueA = Number(this.getSortValue(a))
      let valueB = Number(this.getSortValue(b))
      if (this.ASC) {
        return valueA - valueB
      } else {
        return valueB - valueA
      }
    },
    changeOrder (order) {
      this.order = order
    },
    onSortClick (e) {
      if (this.sort && e.target.className.indexOf('unsort') === -1) {
        this.sortColumn()
      }
    },
    sortColumn (sortOrder) {
      let columns = this.table.columns
      columns.forEach((column, index) => {
        if (index !== this.columnIndex) {
          column.changeOrder('')
        }
      })
      if (sortOrder) {
        this.changeOrder(sortOrder)
      } else {
        if (this.macTable) this.order = this.macTable
        if (this.order === '') {
          this.changeOrder('asc')
        } else {
          if (this.order === 'asc') {
            this.changeOrder('desc')
          } else {
            this.changeOrder('asc')
          }
        }
      }
      if (this.$router.currentRoute.name.includes('mactable')) {
        this.macTable = this.order
      }
      this.table.lastSortCompare = (this.number) ? this.sortNumber : this.sortString
      this.table.calculate()
      // this.table.data.sort(this.sortCompare);
    }
  }
}
</script>
<style lang="scss">
@import '../../../assets/scss/variables.scss';
.qweb-column {
  // text-align: center;
  vertical-align: middle;
  padding: 0px 16px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #4C4C4C;
  display: inline-block;
  position: relative;
  border-bottom: 1px solid #e5e5e5;
  font-family: 'Roboto-M' !important;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  &:first-child {
    border-left: 0px;
  }
  /* &.sort {
    &:hover {
      background-color: #717886;
    }
  } */
  >.qweb-column-title {
    // line-height: 27px;
    // font-size: 14px;
    // color: #4C4C4C;
    // margin-left: 20px; // width: calc(100% - 20px);
    vertical-align: super;
    line-height: 40px;
    font-size: 14px;
    color: #000000;
  }
  // &:hover {
  //   >.overlay {
  //     >.sort-default {
  //       display: block;
  //     }
  //   }
  // }
  >.overlay {
    position: absolute;
    height: 100%;
    top: 0;
    right: 5px;
    padding-right: 0px;
    display: flex;
    align-items: center;
    >.sort-default {
      // display: block;
      width: 6px;
      height: 12px;
      background-image: url("../../../assets/table/table_sort_default.png");
    }
    >.sort-asc {
      width: 6px;
      height: 4px;
      background-image: url("../../../assets/table/table_sort_up.png");
    }
    >.sort-desc {
      width: 6px;
      height: 4px;
      background-image: url("../../../assets/table/table_sort_down.png");
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/table/column/Column.vue